module.exports = __webpack_public_path__ + "static/media/dolla.5a59fb8f.png";